<router-outlet></router-outlet>
<app-call></app-call>
